import { CancelUnitModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_MANAGE } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  loading?: boolean
  unit: IUnitGenericDetailsModel | undefined
}

export const CancelUnitButton: React.FC<IProps> = ({ loading, unit }) => {
  const { navigateReplace } = useNavigation()

  return (
    <ModalButton
      component={CancelUnitModal}
      disabled={loading}
      componentProps={{ unit }}
      enterAnimation={modalSlideUpEnterAnimation}
      leaveAnimation={modalSlideUpLeaveAnimation}
      backdropDismiss
      confirmCallback={() =>
        navigateReplace({
          route: ROUTE_UNIT_MANAGE,
          routeUrl: ROUTE_UNIT_MANAGE.buildPath(UNIT_STATUS_CANCELLED.value, unit?.unitId)
        })
      }
    >
      <ButtonRoundLg
        type='div'
        loading={loading}
        disabled={loading}
        className='action-error'
        tooltip={{ id: 'device-cancel-now', place: 'bottom', message: 'Cancel now' }}
      >
        <commonIcons.delete className='!text-[1.1rem]' />
      </ButtonRoundLg>
    </ModalButton>
  )
}
